const messages = {
  title: "Trgovina",
  description: "Dobrodošli u shop nagrada. Ovde možete unovčiti vaše Bridgestone Plus poene <br/> za nagrade iz različitih kategorija. Ponuda proizvoda <br/> se redovno ažurira. Uživajte u pregledanju.",
  sort: {
    asc: "Sortirajte po: Najniža cena",
    desc: "Sortirajte po: Najviša cena",
  },
  productSearchBox: {
    from: "poeni od",
    to: "poeni do",
  },
  noProducts: "Kriterijumi pretrage nisu dali rezultate",
  quantity: "Količina",
  search: "Pretražite",
  perPage: "Stavki po stranici",
  timeUnavailable: "Trenutno nije dostupno u ovom trenutku",
  product: "Proizvod",
  cart: {
    pointsPerUnit: "Poeni po jedinici",
    pointsSum: "Zbir poena",
  },
  action: "Akcija",
  pointsTotal: "Ukupno",
  cartRemainPoints: "Preostali poeni u korpi",
  shoppingCart: "Korpa",
  emptyCart: "Korpa je prazna.",
  attributes: "Atributi",
  selectAddressP: "Molimo izaberite vašu adresu za dostavu",
  orderDelivery: "Adresa za dostavu",
  selectedProducts: "Izabrani proizvodi",
  orderSummary: "Pregled narudžbe",
  contactPerson: "Kontakt osoba",
  selectedAddress: "Izabrana adresa",
  order: {
    success: "Hvala vam! Vaša narudžba je uspešna. Primićete potvrdu narudžbe u vašoj primljenoj pošti za nekoliko minuta.",
    description: "Ovde ćete pronaći pregled vaših narudžbi iz shopa nagrada.",
    info: "Ovde ćete pronaći pregled vaših narudžbi iz shopa nagrada.",
    date: "Datum narudžbe",
    number: "Br. narudžbe",
    status: {
      created: "Kreirano",
      confirm_order: "Potvrdite narudžbu",
      ready_for_shipment: "Spremno za slanje",
      rejected: "Odbijeno",
      processed: "Obrađeno",
      shipped: "Poslano",
      returned: "Vraćeno",
      finished: "Završeno",
    },
    anyOrder: "Nema narudžbi",
    products: "Proizvodi",
    quantity_short: "kom",
    itemRemoved: "nije moguće isporučiti",
  },
  orders: "Narudžbe",
  notEnoughPoints: "Nema dovoljno dostupnih poena.",
  statusText: "Status",
  outOfStock: "Trenutno nije na stanju",
  productUnavailable: "Ovaj proizvod više nije dostupan.",
  deletedProductsTitle: "Proizvodi više nisu dostupni",
  deletedProductsMessage: "Sljedeći proizvodi više nisu dostupni. Uklonite ih iz korpe kako biste nastavili.",
  removeSelected: "Ukloni izabrano",
  clearCart: "Isprazni korpu",
  removeSelectedConfirm: "Ukloniti izabrane proizvode iz korpe?",
  clearCartConfirm: "Ukloniti sve proizvode iz korpe?",
  incompleteAddress: {
    firstName: "Dodajte ime u adresu za dostavu",
    lastName: "Dodajte prezime u adresu za dostavu",
    company: "Dodajte naziv kompanije u adresu za dostavu",
    street: "Dodajte ulicu i kućni broj u adresu za dostavu",
    postalCode: "Dodajte poštanski broj u adresu za dostavu",
    city: "Dodajte grad u adresu za dostavu",
    country: "Dodajte državu u adresu za dostavu",
    phone: "Dodajte broj telefona u adresu za dostavu",
  },
  placeOrder: "Obvezujuća narudžba",
  toOrderDelivery: "Nastavi na adresu dostave",
  toOrderSummary: "Na pregled narudžbe",
  productImg: "Slika proizvoda",
  selectAddressBtn: "Odaberi adresu",
  perPgae: "Stavki po stranici",
  categories: {
    advertising: {
      title: "Reklamni materijali",
      desc: "Sudjelujte izravno ovdje na platformi i osigurajte <br/> 40 dodatnih bodova za klub nagrada.",
    },
    rewards: {
      title: "Ekskluzivne nagrade",
      desc: "Otkrijte bonus ponudu u našem centru za obuku ili na vašoj lokaciji.",
    },
    tools: {
      title: "Alati za radionicu",
      desc: "Iskoristite bodove za obuke trećih strana <br/> i smanjite troškove.",
    },
    trainings: {
      title: "Obuke i tečajevi",
      desc: "Otkrijte bonus ponudu u našem centru za obuku ili na vašoj lokaciji.",
    },
    salesroom: {
      title: "Prodajni prostor",
      desc: "Uredite prodajni prostor i ponudite klijentima ugodan boravak.",
    },
    hunter: {
      title: "Hunter",
      desc: "Zamijenite bodove za atraktivnu opremu radionice Hunter.",
    },
  },
  bestSold: "Najprodavanije",
  seasonal: "Sezonsko",
  affordable: "Skoro gotovo",
  forPoints: "za {points} bodova",
  reachedPoints: "Potrebni bodovi postignuti",
  remainingPoints: "Nedostaje {points} bodova",
  favoriteProducts: {
    description: "Ovdje ćete pronaći sačuvane proizvode.",
  },
  categoryPageDescriptionFallback: "Materijal za radionicu ili drugi kvalitetni proizvodi sa Bridgestone logotipom za vaše preduzeće",
  variant: "Varijante na izbor",
};
export default {
  messages,
};
